/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A header row names the items shown in the legend.`)
};

const es_radar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una fila de cabecera nombra los elementos que se muestran en la leyenda.`)
};

const de_radar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Kopfzeile benennt die in der Legende angezeigten Elemente.`)
};

const nl_radar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een headerrij benoemt de items die in de legenda worden getoond.`)
};

const fr_radar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une ligne d'en-tête nomme les éléments affichés dans la légende.`)
};

const it_radar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una riga di intestazione nomina gli elementi mostrati nella legenda.`)
};

const pt_br2_radar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha de cabeçalho nomeia os itens mostrados na legenda.`)
};

const pt_radar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha de cabeçalho nomeia os itens mostrados na legenda.`)
};

const ja_radar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘッダー行は凡例に表示される項目名を指定します。`)
};

const zh_radar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表头行为图例中显示的项目命名。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_ex3", locale)
	if (locale === "en") return en_radar_ex3(inputs)
	if (locale === "es") return es_radar_ex3(inputs)
	if (locale === "de") return de_radar_ex3(inputs)
	if (locale === "nl") return nl_radar_ex3(inputs)
	if (locale === "fr") return fr_radar_ex3(inputs)
	if (locale === "it") return it_radar_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_radar_ex3(inputs)
	if (locale === "pt") return pt_radar_ex3(inputs)
	if (locale === "ja") return ja_radar_ex3(inputs)
	return zh_radar_ex3(inputs)
};